<script setup>
import { useAuth } from '@/stores/auth.js'
import { ref } from 'vue'
import { notNull } from '@/rules.js'
import { v4 as uuid4 } from 'uuid'

let auth = useAuth()
const isFormValid = ref(false)
const username = ref()
const emit = defineEmits(['onSave'])

const onFormSubmit = () => {
  if (!isFormValid.value) {
    return
  }
  auth.username = username.value
  auth.id = uuid4()
  auth.observer = false
  emit('onSave')
}
</script>

<template>
  <v-form v-model="isFormValid" fast-fail @submit.prevent="onFormSubmit">
    <v-text-field
      v-model="username"
      :rules="[notNull]"
      density="comfortable"
      label="Username"></v-text-field>
    <v-btn class="mt-8" block type="submit">Login</v-btn>
  </v-form>
</template>

<style scoped></style>
